<template>
  <div class="loading">
    <!-- 遮罩层 -->
    <!-- <van-overlay :show="s_loading" class="overlay-wrapper">
      <van-loading type="spinner">加载中...</van-loading>
    </van-overlay> -->
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters('global', ['s_loading']),
    },
    data() {
      return {
        loadingI:null,
        fullscreenLoading: false
      }
    },
    watch: {
        s_loading(nVal){
          console.log(nVal);
          if(nVal){
            this.loadingF();
          }else{
            this.loadingI.close();
          }
        },
    },
    created() {
          console.log('this.s_loading');

    },
    mounted() {
          console.log(this.s_loading);
    },
    methods: {
      loadingF() {
        //  this.fullscreenLoading = true;
        this.loadingI = this.$loading({
          lock: true,
          text: '正在拼命加载',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    }

  }
</script>

<style lang="scss" scoped>
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;

    .overlay-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      .van-loading__spinner{
        width: 60px;
        height: 60px;
      }
      .van-loading__text {
        font-size: 28px;
      }
    }
  }
</style>